import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/auth/resetPassword';

import { validateResetPasswordFieldValue } from './utils';

export default function* listenSetResetPasswordFieldValue() {
  yield takeEvery(actionTypes.setResetPasswordFieldValue, validateResetPasswordFieldValue);
}
